import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../../../services/user.service";

@Component({
  selector: 'app-notifications-bar',
  templateUrl: './notifications-bar.component.html',
  styleUrls: ['./notifications-bar.component.scss']
})
export class NotificationsBarComponent implements OnInit {

  @Input() icon: string = 'fa-bell';
  @Input() items: Array<any> = [];
  @Output() viewAllClicked: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router,
              private userService: UserService) {
  }

  ngOnInit() {
  }

  viewAll() {
    this.viewAllClicked.emit();
    if (this.userService.isSuperAdmin()) {
      this.router.navigateByUrl("/admin/notifications-list")
    } else if (this.userService.isReseller()) {
      this.router.navigateByUrl("/reseller/notifications-list")
    } else if (this.userService.isVendor()) {
      this.router.navigateByUrl("/vendor/notifications-list")
    } else if (this.userService.isBuyer()) {
      this.router.navigateByUrl("/buyer/notifications-list")
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/notifications/notifications-bar/notifications-bar.component.ts